import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.css']
})
export class UsersListComponent implements OnInit {

  cid: any
  data: any;
  form: any | FormGroup;
  paramForm: any | FormGroup;
  modelSubtitle = false
  users: any = []
  checked = false
  name = ""
  version = ""
  isActive = false
  i: any;
  deleteId: any = "";
  userParameters: any = []
  userId = ''
  paramData: any = []
  roles: any = []
  selectedRoleId: any = ""
  userTypes: any = []
  searchUser = ""
  buttonDisable = false
  selectedUserData: any = []
  formSubmit = false;
  userPrivileges: any = []
  usersWithoutCustomers: any = []
  selectedRoleData: any = []
  userParams: any = []
  paginatorVisible: any = true
  pageNumber: number = 0;
  pageNumber1: number = 0;
  totalRecords: number = 0;
  recordsPerPage: number = 10;
  first: any = 0
  tableSize: number = 10;

  userData: any = []

  editForm: any | FormGroup;

  rolesList: any = [];
  rolesSelectedList: any = [];
  rolesDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'roleId',
    textField: 'roleName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 2,
    allowSearchFilter: true
  };

  languages: any = [
    { label: 'English', value: 'en' },
    { label: 'French', value: 'fr' },
    { label: 'Hindi', value: 'hi' },
    { label: 'Telugu', value: 'te' },
    { label: 'German', value: 'de' }
  ];

  dashboardList = [
    // { dashboardId: 1, dashboardName: "CRM Dashboard" },
    { dashboardId: 2, dashboardName: "Tickets Dashboard" },
    { dashboardId: 12, dashboardName: "Asset Allocations Dashboard" },
    { dashboardId: 13, dashboardName: "Asset Inventory & Financials Dashboard" },
    { dashboardId: 14, dashboardName: "Logistics & Transit Dashboard" },
    { dashboardId: 15, dashboardName: "Operational Health & Maintenance Dashboard" }

  ];


  dashboardSelectedList: any = [];
  dashboardDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'dashboardId',
    textField: 'dashboardName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 2,
    allowSearchFilter: true
  };





  locationList: any = []
  locationSelectedList: any = [];
  locationDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'locationId',
    textField: 'zone',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 2,
    allowSearchFilter: true
  };

  objectGroupData: any = []
  objectGroupDataSelectedList: any = [];
  objectGroupDataDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'objectGroupMasterId',
    textField: 'groupName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 2,
    allowSearchFilter: true
  };


  branchList: any = []
  branchSelectedList: any = [];
  branchDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'branchMasterId',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 2,
    allowSearchFilter: true
  };

  departmentList: any = []
  departmentSelectedList: any = [];
  departmentDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'departmentInfoId',
    textField: 'departmentName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 2,
    allowSearchFilter: true
  };


  actionControls: any = {
    isAdd: false,
    isView: false,
    isDelete: false,
    isModify: false,

  }
  userCred: any = []
  isRoleSubmit: boolean = false;
  recordId: any = "";
  recordName: any = "";


  constructor(private fb: FormBuilder, private toastr: ToastrService, private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = Number(sessionStorage.getItem('cid'))
    let href: any = window.location.href;
    let messages = href.split('/')
    let action: any = this.generic_service.checkActionControls(messages[messages.length - 1])
    this.actionControls = action
    this.userCred = JSON.parse(sessionStorage.getItem('userCreds')!);
    this.rolesList = this.userCred.roleSet || []
    // this.getAllRoles()
    this.getAllUsers(this.pageNumber, this.recordsPerPage)
    this.getUsersWithoutCustomers()
    this.getParamByType()
    this.getParam()
    this.getAllLocation()
    this.getAllGroupList()
    this.getAllDepartment_info()
    this.getAllBranch()
    this.form = this.fb.group({
      userName: ['', [Validators.required]],
      userMobileNo: ['', [Validators.required,
      Validators.maxLength(20),
      Validators.minLength(9),
      Validators.pattern("[0-9 ]{10}")]],
      userEmail: ['', [Validators.required,
      Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,3}$"),
      ]],
      password: ['', [Validators.required]],
      userType: ['', [Validators.required]],
      reportsTo: [''],
      companyName: [''],
      language: [''],
      location: [''],
      isOnSite: [false],
      user: ['']
    })

    this.editForm = this.fb.group({
      userName: ['', [Validators.required]],
      userMobileNo: ['', [Validators.required,
      Validators.maxLength(20),
      Validators.minLength(9),
      Validators.pattern("[0-9 ]{10}")]],
      userEmail: ['', [Validators.required,
      Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,3}$"),
      ]],
      userType: ['', [Validators.required]],
      reportsTo: [''],
      userId: [],
      language: [''],
      location: [''],
      isOnSite: [false],
      id: [''],
      user: ['']
    })


    this.paramForm = this.fb.group({
      paramObj: this.fb.array([])
    })
    // this.addInfoObject()
  }

  onTableDataChange(event: any) {
    console.log(event)
    this.pageNumber = event.page;
    this.first = event.first;
    this.recordsPerPage = event.rows;


    if (this.searchUser != "") {
      this.searchCustomer(this.pageNumber, this.recordsPerPage)
    } else {
      this.getAllUsers(this.pageNumber, this.recordsPerPage);
    }
  }

  get paramArr() {
    return this.paramForm.get('paramObj') as FormArray;
  }

  getAllBranch() {
    this.generic_service.getBranch().subscribe(
      (response: any) => {
        this.branchList = response.response;

      }
    )
  }


  getAllDepartment_info() {
    this.generic_service.getAllDepartment_info().subscribe(
      (res: any) => {
        console.log(res)
        this.departmentList = res.response
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  getAllGroupList() {
    this.generic_service.getAllGroupList().subscribe(
      (res: any) => {
        console.log(res)
        this.objectGroupData = res.response || []
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  getAllLocation() {
    this.generic_service.getAllLocation().subscribe(
      (res: any) => {
        console.log(res)
        this.locationList = res.response || []
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  paramObject() {
    let obj = {
      "name": "",
      "possibleValue": []
    }
    this.paramData.push(obj)
    return this.fb.group({
      "key": [''],
      "value": [''],
    })
  }

  addInfoObject() {
    // this.infoArr.clear()
    this.paramArr.push(this.paramObject())
  }

  removeParamObject(index: number) {
    this.paramData.splice(index, 1)
    this.paramArr.removeAt(index)
  }

  addParam() {
    let userParam = []
    let userParam1 = this.paramForm.get('paramObj').value

    for (let i = 0; i < userParam1.length; i++) {
      if (userParam1[i].value != '') {
        userParam.push(userParam1[i])
      }
    }
    if (this.userParameters.length == 0) {
      let body = {
        "userId": Number(this.userId),
        "userParam": userParam,
        "cid": Number(sessionStorage.getItem('cid'))
      }
      console.log(body)
      this.generic_service.addUserParameter(body).subscribe(
        (response: any) => {
          this.getUserParameter(this.userId)
          console.log(response)
          this.paramArr.reset()
          // this.addInfoObject()
        },
        (error: any) => {
          console.log(error)
        }
      )
    } else {
      let body = userParam
      console.log(body)
      this.generic_service.addUserParameterByUserId(this.userId, body).subscribe(
        (response: any) => {
          this.getUserParameter(this.userId)
          console.log(response)
          // this.paramArr.clear()
          // this.addInfoObject()
          this.form.reset()

        },
        (error: any) => {
          console.log(error)
        }
      )
    }



  }

  addUserButton() {
    this.form.reset();
    this.formSubmit = false;
  }


  clearData() {
    this.dashboardSelectedList = []
    this.locationSelectedList = []
    this.objectGroupDataSelectedList = []
    this.branchSelectedList = []
    this.departmentSelectedList = []
    this.form.reset()
    this.getParamByType()
  }

  addSelectedUserRoles(user: any) {
    const selectedUserId = this.form.get('user')?.value;
    const selectedUser = this.usersWithoutCustomers.find((u: any) => u.userId == selectedUserId);

    if (selectedUser) {
      this.formSubmit = true;
      this.buttonDisable = true;

      let body = {
        "version": 0,
        "isActive": true,
        "description": "",
        "roleSet": selectedUser.roleSet || [],
        "userId": Number(user?.userId || 0),
        "cid": Number(this.cid || 0)
      };

      this.generic_service.updateAddRoleSetToAUser(body).subscribe(
        (response: any) => {
          this.getAllUsers(this.pageNumber, this.recordsPerPage);
          this.toastr.success(response?.response?.message || "Successfully updated user roles");
          this.cancelModel();
          this.form.reset();
          this.locationSelectedList = [];
          this.departmentSelectedList = [];
          this.branchSelectedList = [];
          this.buttonDisable = false;
          this.formSubmit = false;
        },
        (err: any) => {
          console.log(err);
          this.formSubmit = false;
          this.toastr.error(err.error?.errors?.[0]?.description || 'Error updating user roles');
          this.buttonDisable = false;
        }
      );
    }
  }

  addlogedUsers() {

    if (!this.form.valid) {
      console.log(this.form.value)
      this.toastr.error("please fill required fields");
      return
    }
    this.buttonDisable = true;
    let keyValues: any = []

    for (let i = 0; i < this.userParams.length; i++) {
      keyValues.push(
        {
          "key": this.userParams[i].name,
          "value": this.userParams[i].value
        }
      )
    }

    let dashboardIds: any = []

    for (let list of this.dashboardSelectedList) {
      dashboardIds.push(list.dashboardId)
    }

    let locations: any = []

    for (let list of this.locationSelectedList) {
      locations.push(list.locationId)
    }


    let groupMasterList = this.objectGroupData.filter((list: any) =>
      this.objectGroupDataSelectedList.some(
        (selected: any) => selected.objectGroupMasterId === list.objectGroupMasterId
      )
    );


    let branch: any = []

    for (let list of this.branchSelectedList) {
      branch.push(list.branchMasterId)
    }

    let department: any = []

    for (let list of this.departmentSelectedList) {
      department.push(list.departmentInfoId)
    }

    if (this.formSubmit) {
      return
    }

    this.formSubmit = true;


    let body: any = {
      "version": 0,
      "isActive": true,
      "description": "",
      "userId": 0,
      "userType": String(this.form.get('userType').value),
      "userName": String(this.form.get('userName').value),
      "userMobileNo": String(this.form.get('userMobileNo').value),
      "userEmail": String(this.form.get('userEmail').value),
      "password": String(this.form.get('password').value),
      "imageURL": "",
      "location": "",
      "dashboardIds": dashboardIds,
      "otp": "",
      "otpGenerateDateTime": 0,
      "keyValues": keyValues,
      "cid": this.cid,
      "isOnSite": this.form.get('isOnSite')?.value || false,
      "companyName": this.userCred.companyName || '',
      "locations": locations,
      "department": department,
      "branch": branch,
      "groupMasterList": groupMasterList,
      "preferences": {
        "localization": {
          "country": "",
          "language": this.form.get('language').value,
          "timezone": "",
          "dateFormat": "",
          "currency": ""
        }
      },
    }

    if (this.form.get('reportsTo').value != null && this.form.get('reportsTo').value != "") {
      body.reportsTo = Number(this.form.get('reportsTo').value)
    }

    console.log(body)
    this.generic_service.addlogedUsers(body).subscribe(
      (response: any) => {
        console.log(response)
        this.getAllUsers(this.pageNumber, this.recordsPerPage)
        this.toastr.success(response.message);

        const selectedUserId = this.form.get('user')?.value;
        if (selectedUserId && selectedUserId !== "") {
          this.addSelectedUserRoles(response.response);
        } else {
          this.cancelModel()
          this.form.reset()
          this.locationSelectedList = []
          this.departmentSelectedList = []
          this.branchSelectedList = []
          this.buttonDisable = false
          this.formSubmit = false;
        }
      },
      (err: any) => {
        console.log(err)
        this.formSubmit = false;
        this.toastr.error(err.error.errors[0].description);
        this.buttonDisable = false

      },
    )
  }

  onItemSelect(item: any) {
    console.log(item);
  }

  onSelectAll(items: any) {
    console.log(items);
  }


  onGroupSelect(item: any) {
    console.log('Selected:', item);
  }

  onGroupSelectAll(items: any) {
    console.log('Selected All:', items);
  }

  onGroupDeSelect(item: any) {
    console.log('Unselected:', item);
  }

  onGroupDeSelectAll(items: any) {
    console.log('Unselected All:', items);
  }


  onRoleItemSelect(item: any) {
    console.log(item);
    if (this.selectedRoleData.some((r: any) => r.roleId == item.roleId)) {
      return;
    }
    let role = this.rolesList.find((r: any) => r.roleId === item.roleId);
    if (role) {
      let roleCopy = JSON.parse(JSON.stringify(role));
      if (roleCopy.screenGroupList) {
        for (let i = 0; i < roleCopy.screenGroupList.length; i++) {
          roleCopy.screenGroupList[i].isChecked = true; // By default checked since it's from the role
          for (let j = 0; j < roleCopy.screenGroupList[i].screenPrivilegeList.length; j++) {
            let screen = roleCopy.screenGroupList[i].screenPrivilegeList[j];
            screen.isChecked = true; // By default checked
            screen.isSelected = true; // To match the HTML you used

            // Store original capability bounds
            screen.isView = screen.view || false;
            screen.isAdd = screen.add || false;
            screen.isDelete = screen.delete || false;
            screen.isModify = screen.modify || false;
            screen.isVerify = screen.verify || false;
            screen.isApprove = screen.approve || false;
            screen.isIssue = screen.issue || false;
            screen.isAttach = screen.attach || false;
            screen.isRemove = screen.remove || false;

            // Set initial state
            screen.view = screen.isView;
            screen.add = screen.isAdd;
            screen.delete = screen.isDelete;
            screen.modify = screen.isModify;
            screen.verify = screen.isVerify;
            screen.approve = screen.isApprove;
            screen.issue = screen.isIssue;
            screen.attach = screen.isAttach;
            screen.remove = screen.isRemove;
          }
        }
      }
      this.selectedRoleData.push(roleCopy);
    }
  }

  isChecked(event: any, r: any, i: any) {
    let group = this.selectedRoleData[r].screenGroupList[i];
    group.isChecked = event.target.checked;
    for (var j = 0; j < group.screenPrivilegeList.length; j++) {
      let screen = group.screenPrivilegeList[j];
      screen.isChecked = event.target.checked;
      screen.isSelected = event.target.checked;
      if (event.target.checked) {
        screen.view = true;
        if (screen.isAdd) screen.add = true;
        if (screen.isModify) screen.modify = true;
        if (screen.isDelete) screen.delete = true;
        if (screen.isVerify) screen.verify = true;
        if (screen.isApprove) screen.approve = true;
        if (screen.isIssue) screen.issue = true;
        if (screen.isAttach) screen.attach = true;
        if (screen.isRemove) screen.remove = true;
      } else {
        screen.view = false;
        screen.add = false;
        screen.modify = false;
        screen.delete = false;
        screen.verify = false;
        screen.approve = false;
        screen.issue = false;
        screen.attach = false;
        screen.remove = false;
      }
    }
  }

  screenCheck(event: any, r: any, i: any, j: any) {
    let group = this.selectedRoleData[r].screenGroupList[i];
    let screen = group.screenPrivilegeList[j];
    screen.isChecked = event.target.checked;
    screen.isSelected = event.target.checked;
    if (event.target.checked) {
      screen.view = true;
      if (screen.isAdd) screen.add = true;
      if (screen.isModify) screen.modify = true;
      if (screen.isDelete) screen.delete = true;
      if (screen.isVerify) screen.verify = true;
      if (screen.isApprove) screen.approve = true;
      if (screen.isIssue) screen.issue = true;
      if (screen.isAttach) screen.attach = true;
      if (screen.isRemove) screen.remove = true;
    } else {
      screen.view = false;
      screen.add = false;
      screen.modify = false;
      screen.delete = false;
      screen.verify = false;
      screen.approve = false;
      screen.issue = false;
      screen.attach = false;
      screen.remove = false;
    }
    group.isChecked = group.screenPrivilegeList.some((s: any) => s.isChecked);
  }

  onRoleDeSelect(item: any) {
    console.log(item);
    this.selectedRoleData = this.selectedRoleData.filter((role: any) => role.roleId != item.roleId);
  }

  onRoleSelectAll(items: any) {
    console.log(items);
    this.selectedRoleData = [];
    items.forEach((item: any) => {
      let role = this.rolesList.find((r: any) => r.roleId === item.roleId);
      if (role) {
        let roleCopy = JSON.parse(JSON.stringify(role));
        if (roleCopy.screenGroupList) {
          for (let i = 0; i < roleCopy.screenGroupList.length; i++) {
            roleCopy.screenGroupList[i].isChecked = true;
            for (let j = 0; j < roleCopy.screenGroupList[i].screenPrivilegeList.length; j++) {
              let screen = roleCopy.screenGroupList[i].screenPrivilegeList[j];
              screen.isChecked = true;
              screen.isSelected = true;

              screen.isView = screen.view || false;
              screen.isAdd = screen.add || false;
              screen.isDelete = screen.delete || false;
              screen.isModify = screen.modify || false;
              screen.isVerify = screen.verify || false;
              screen.isApprove = screen.approve || false;
              screen.isIssue = screen.issue || false;
              screen.isAttach = screen.attach || false;
              screen.isRemove = screen.remove || false;

              screen.view = screen.isView;
              screen.add = screen.isAdd;
              screen.delete = screen.isDelete;
              screen.modify = screen.isModify;
              screen.verify = screen.isVerify;
              screen.approve = screen.isApprove;
              screen.issue = screen.isIssue;
              screen.attach = screen.isAttach;
              screen.remove = screen.isRemove;
            }
          }
        }
        this.selectedRoleData.push(roleCopy);
      }
    });
  }

  onRoleDeSelectAll(items: any) {
    console.log(items);
    this.selectedRoleData = [];
  }

  onUserSelect(event: any) {
    const selectedUserId = event.target.value;
    const selectedUser = this.usersWithoutCustomers.find((u: any) => u.userId == selectedUserId);
    console.log("Selected User: ", selectedUser);
  }

  cancelModel() {
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("editCloseModal")?.click()
    this.clearData()
    this.recordId = "";
    this.recordName = "";
  }

  ngOnDestroy() {
    console.log("ngOnDestroy")
  }

  async getParamByType() {
    let paramType = "USERPARAMS"

    try {
      const response: any = await firstValueFrom(this.generic_service.getParamByType(paramType));

      console.log(response)

      this.userParams = []
      for (let key of response.response) {
        if (key.boxType != null && key.boxType != "" && key.boxType != undefined) {

          if (key.boxType == 'Dropdown') {
            if (key.api != '' && key.api != null && key.api != undefined) {
              const res: any = await firstValueFrom(this.generic_service.getByApiName(key.api));
              key.possibleValue = res.response
            }
          }


          let obj = {
            name: key.name,
            boxType: key.boxType,
            isMandatory: key.isMandatory,
            possibleValue: key.possibleValue,
            value: "",
          }
          this.userParams.push(obj);

        }
      }

      console.log(this.userParams)

    } catch (err) {
      console.error("Error fetching user params:", err);

    }

  }

  getAllUsers(pageNumber: any, recordsPerPage: any) {
    this.isLoading = true

    this.generic_service.getAllUsers(pageNumber, recordsPerPage).subscribe(
      (response: any) => {
        console.log(response);
        let arr = []
        for (var i = 0; i < response.response.userList.length; i++) {
          if (response.response.userList[i].userType.toLowerCase() != 'su') {
            arr.push(response.response.userList[i])
          }
        }
        this.users = arr;
        this.totalRecords = response.response.totalRecords

        console.log(this.users)
        this.isLoading = false

      }
    )
  }

  open() {
    this.modelSubtitle = true;
  }

  close() {
    this.modelSubtitle = false;
    this.name = ""
    this.version = ""
    this.isActive = false
  }

  getUserParameter(userId: any) {
    this.userId = userId
    this.generic_service.getUserParameterByUserId(userId).subscribe(
      (response: any) => {
        console.log(response)
        this.userParameters = []
        this.userParameters = response.response.userParam;
        this.getParamsData()

      },
      (error: any) => {
        this.userParameters = []
        console.log(error)
        this.getParamsData()

      }
    )
  }



  getParamsData() {
    this.paramArr.clear()

    this.generic_service.getParams().subscribe(
      (res: any) => {
        console.log(res)
        let arr = []
        for (var i = 0; i < res.response.length; i++) {
          if (res.response[i].type == "USERPARAMS") {
            arr.push(res.response[i])
          }
        }
        this.paramData = arr;
        let list = []
        let list1 = []

        if (this.userParameters.length == 0) {

          for (var i = 0; i < this.paramData.length; i++) {
            let obj = this.fb.group({
              "key": [this.paramData[i].name],
              "value": [''],
            })
            this.paramArr.push(obj)
          }
        } else {

          let paramData = []
          for (var i = 0; i < this.paramData.length; i++) {
            for (var j = 0; j < this.userParameters.length; j++) {
              if (this.userParameters[j].key == this.paramData[i].name) {
                paramData.push(this.paramData[i].name)
              }
            }
          }
          for (var i = 0; i < this.paramData.length; i++) {
            if (paramData.includes(this.paramData[i].name)) {

            } else {
              list1.push(this.paramData[i])
              let obj = this.fb.group({
                "key": [this.paramData[i].name],
                "value": [''],
              })
              this.paramArr.push(obj)
            }
            // list1.push(this.paramData[i])
            // let obj = this.fb.group({
            //   "key": [this.paramData[i].name],
            //   "value": [''],
            // })
            // this.paramArr.push(obj)

          }
          this.paramData = list1;
          // if(this.paramData.length == 0){
          //   this.addInfoObject()
          // }

        }
      },
      (err: any) => {
        console.log(err)
      }
    )
  }




  getAllRoles() {
    this.generic_service.getAllRoles().subscribe(
      (response: any) => {
        console.log(response)
        this.roles = response.response
        // this.rolesList = response.response

        // if(response.response && response.response.length !=0){
        //   for(let list of response.response){
        //     let obj: any = {
        //       roleId: list.roleId,
        //       roleName: list.roleName,
        //       isSelected: false
        //     }
        //     this.rolesList.push(obj)
        //   }
        // }
        console.log(this.roles)
        console.log(this.rolesList)

      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  searchCustomer(pageNumber: any, recordsPerPage: any) {
    this.pageNumber = pageNumber;
    this.recordsPerPage = recordsPerPage;
    this.first = pageNumber * recordsPerPage;
    if (this.searchUser != "") {
      this.isLoading = true

      this.generic_service.searchCustomer(this.searchUser, pageNumber, recordsPerPage).subscribe(
        (response: any) => {
          console.log(response);
          let arr = []
          // for (var i = 0; i < response.response.userList.length; i++) {
          //   if (response.response.userList[i].userType.toLowerCase() != 'su') {
          //     arr.push(response.response.userList[i])
          //   }
          // }
          this.users = response.response.userList;
          this.totalRecords = response.response.totalRecords

          console.log(this.users)
          this.isLoading = false

        },
        (err: any) => {
          console.log(err)
        }
      )

    } else {
      this.getAllUsers(this.pageNumber, this.recordsPerPage)
    }

  }


  userSelected(user: any) {
    console.log(user)
    this.selectedRoleId = "";
    this.selectedUserData = [];
    this.selectedUserData.push(user);

    this.selectedRoleData = [];
    this.rolesSelectedList = [];

    if (user.roleSet && user.roleSet.length > 0) {
      for (let role of user.roleSet) {
        console.log(role)
        let matchingRole = this.rolesList.find((rl: any) => rl.roleId == role.roleId);

        if (!matchingRole) continue;

        let r: any = JSON.parse(JSON.stringify(matchingRole));
        if (r.screenGroupList) {
          for (let i = 0; i < r.screenGroupList.length; i++) {
            // Match group strictly by groupName (ignore screenGroupId if it's 0 or undefined to avoid false positives)
            let userGroup = role.screenGroupList?.find((g: any) => g.groupName === r.screenGroupList[i].groupName || (g.screenGroupId && r.screenGroupList[i].screenGroupId && g.screenGroupId === r.screenGroupList[i].screenGroupId));

            if (r.screenGroupList[i].screenPrivilegeList) {
              for (let j = 0; j < r.screenGroupList[i].screenPrivilegeList.length; j++) {
                let screen = r.screenGroupList[i].screenPrivilegeList[j];

                // Store original capability bounds from rolesList
                screen.isView = screen.view || false;
                screen.isAdd = screen.add || false;
                screen.isDelete = screen.delete || false;
                screen.isModify = screen.modify || false;
                screen.isVerify = screen.verify || false;
                screen.isApprove = screen.approve || false;
                screen.isIssue = screen.issue || false;
                screen.isAttach = screen.attach || false;
                screen.isRemove = screen.remove || false;

                // Match screen strictly by name (ignore id if it's undefined to avoid undefined === undefined false positives)
                let userScreen = userGroup?.screenPrivilegeList?.find((s: any) => s.name === screen.name || (s.id && screen.id && s.id === screen.id));

                if (userScreen) {
                  screen.isChecked = userScreen.view || userScreen.add || userScreen.modify || userScreen.delete || userScreen.verify || userScreen.approve || userScreen.issue || userScreen.attach || userScreen.remove || false;
                  screen.isSelected = screen.isChecked;

                  screen.view = userScreen.view || false;
                  screen.add = userScreen.add || false;
                  screen.delete = userScreen.delete || false;
                  screen.modify = userScreen.modify || false;
                  screen.verify = userScreen.verify || false;
                  screen.approve = userScreen.approve || false;
                  screen.issue = userScreen.issue || false;
                  screen.attach = userScreen.attach || false;
                  screen.remove = userScreen.remove || false;
                } else {
                  screen.isChecked = false;
                  screen.isSelected = false;

                  screen.view = false;
                  screen.add = false;
                  screen.delete = false;
                  screen.modify = false;
                  screen.verify = false;
                  screen.approve = false;
                  screen.issue = false;
                  screen.attach = false;
                  screen.remove = false;
                }
              }
            }
            r.screenGroupList[i].isChecked = r.screenGroupList[i].screenPrivilegeList?.some((s: any) => s.isChecked);
          }
        }

        this.selectedRoleData.push(r);
        this.rolesSelectedList.push(matchingRole);
      }
    }
    console.log(this.selectedUserData);
  }

  addRoleToUser() {
    if (this.selectedRoleData.length == 0) {
      this.toastr.error("please select role");
      return
    }

    if (this.isRoleSubmit) {
      return
    }

    this.isRoleSubmit = true;

    // Construct roleSet array based on API format
    let roleSet = [];
    for (let role of this.selectedRoleData) {
      let screenGroupList = [];
      for (let group of role.screenGroupList || []) {
        if (group.isChecked) {
          let screenPrivilegeList = [];
          for (let priv of group.screenPrivilegeList || []) {
            if (priv.isChecked) {
              screenPrivilegeList.push({
                "seqNo": Number(priv.seqNo || 0),
                "name": String(priv.name || ""),
                "description": String(priv.description || ""),
                "add": Boolean(priv.add),
                "view": Boolean(priv.view),
                "modify": Boolean(priv.modify),
                "delete": Boolean(priv.delete),
                "verify": Boolean(priv.verify),
                "approve": Boolean(priv.approve),
                "issue": Boolean(priv.issue),
                "attach": Boolean(priv.attach),
                "remove": Boolean(priv.remove),
                "originalName": String(priv.originalName || ""),
                "screenPrivilegeScopeList": priv.screenPrivilegeScopeList || []
              });
            }
          }
          screenGroupList.push({
            "version": Number(group.version || 0),
            "isActive": Boolean(group.isActive !== false),
            "description": String(group.description || ""),
            "screenGroupId": Number(group.screenGroupId || group.id || 0),
            "seqNo": Number(group.seqNo || 0),
            "groupName": String(group.groupName || ""),
            "screenPrivilegeList": screenPrivilegeList,
            "cid": Number(group.cid || this.cid || 0)
          });
        }
      }

      roleSet.push({
        "version": Number(role.version || 0),
        "isActive": Boolean(role.isActive !== false),
        "description": String(role.description || ""),
        "id": String(role.id || ""),
        "roleId": Number(role.roleId || 0),
        "roleName": String(role.roleName || ""),
        "level": Number(role.level || 0),
        "screenGroupList": screenGroupList,
        "cid": Number(role.cid || this.cid || 0)
      });
    }

    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "roleSet": roleSet,
      "userId": Number(this.selectedUserData[0].userId || 0),
      "cid": Number(this.cid || 0)
    };

    console.log(body)
    this.generic_service.updateAddRoleSetToAUser(body).subscribe(
      (response: any) => {
        console.log(response)
        this.getAllUsers(this.pageNumber, this.recordsPerPage)
        this.selectedRoleId = ""
        this.selectedRoleData = []
        this.isRoleSubmit = false

        document.getElementById("roleClose")?.click();
        setTimeout(() => {
          this.getUserRoleByUserMobileAndCid(this.selectedUserData[0].userMobileNo)
        }, 500);
      },
      (error: any) => {
        this.isRoleSubmit = false
        this.toastr.error(error.error?.errors?.[0]?.description || error.errors?.[0]?.description || 'Error updating roles');
        console.log(error)
      }
    )
  }

  showUserPrivileges(userDetails: any) {
    this.userPrivileges = []
    let arr = [userDetails]
    this.userPrivileges = arr.slice()
  }

  privilegeAdjust(index: any, position: any) {
    var arr = this.userPrivileges[0].rolePrevilages;
    if (position == 'up') {
      var currentPosition = Number(index);
      var pos = Number(index) - 1;
      var temp = arr[currentPosition];
      var i;
      for (i = currentPosition; i >= pos; i--) {
        arr[i] = arr[i - 1];
      }
      arr[pos] = temp;
    }

    if (position == 'down') {
      var currentPosition = Number(index);
      var pos = Number(index) + 1;
      var temp = arr[currentPosition];
      var i;
      for (i = currentPosition; i <= pos; i++) {
        arr[i] = arr[i + 1];
      }
      arr[pos] = temp;
    }
  }

  screenPrivilegeListAdjust(privilegeIndex: any, screenIndex: any, position: any) {
    var arr = this.userPrivileges[0].rolePrevilages[privilegeIndex].screenPrivilegeList;
    if (position == 'up') {
      var currentPosition = Number(screenIndex);
      var pos = Number(screenIndex) - 1;
      var temp = arr[currentPosition];
      var i;
      for (i = currentPosition; i >= pos; i--) {
        arr[i] = arr[i - 1];
      }
      arr[pos] = temp;
    }

    if (position == 'down') {
      var currentPosition = Number(screenIndex);
      var pos = Number(screenIndex) + 1;
      var temp = arr[currentPosition];
      var i;
      for (i = currentPosition; i <= pos; i++) {
        arr[i] = arr[i + 1];
      }
      arr[pos] = temp;
    }
  }

  updatePosition() {
    console.log(this.userPrivileges)
    console.log(this.users)
  }

  getUsersWithoutCustomers() {
    this.generic_service.getUsersWithoutCustomers().subscribe(
      (res: any) => {
        this.usersWithoutCustomers = res.response;
      }
    )
  }

  roleSelected() {

  }

  getSingleRoleById(roleId: any) {
    this.deleteClose()
    this.generic_service.getRoleById(roleId).subscribe(
      (response: any) => {
        console.log(response)
        this.selectedRoleData = []
        this.selectedRoleData.push(response.response)
      },
      (error: any) => {
        console.log(error)
      }
    )
  }


  getParam() {
    let paramType = "USERTYPE"
    this.generic_service.getParamByType(paramType).subscribe(
      (response: any) => {
        console.log(response);
        for (let key of response.response) {
          this.userTypes = key.possibleValue;
        }
        console.log(this.userTypes);

      },
      (err: any) => {
        console.log(err)
      }
    )
  }




  getUserById(userId: any) {
    this.generic_service.getUserById(userId).subscribe(
      (response: any) => {
        console.log(response)
        this.userData = []
        this.userData.push(response.response)



        this.editForm.patchValue({
          userName: response.response.userName,
          userType: response.response.userType,
          userMobileNo: response.response.userMobileNo,
          userEmail: response.response.userEmail,
          password: response.response.password,
          id: response.response.id,
          userId: response.response.userId,
          reportsTo: response.response.reportsTo,
          location: response.response.location,
          isOnSite: response.response.isOnSite,
        })

        this.dashboardSelectedList = []


        for (let list of response.response.dashboardIds) {
          for (let dashboard_list of this.dashboardList) {
            if (list == dashboard_list.dashboardId) {
              this.dashboardSelectedList.push(dashboard_list)
            }
          }
        }

        this.locationSelectedList = []

        this.locationSelectedList = this.locationList
          ?.filter((locationItem: any) => response.response?.locations?.includes(locationItem.locationId))
          ?.map((locationItem: any) => ({
            locationId: locationItem.locationId,
            zone: locationItem.zone
          })) || [];



        // for(let list of response.response?.groupMasterList){
        //   for(let data of this.objectGroupData){
        //     if(data.objectGroupMasterId == list.objectGroupMasterId){
        //       this.objectGroupDataSelectedList.push(
        //         {
        //           objectGroupMasterId: list.objectGroupMasterId,
        //           groupName: list.groupName
        //         }
        //       )
        //     }
        //   }
        // }




        // this.objectGroupDataSelectedList = response.response?.groupMasterList
        // .filter((list: any) =>
        //   this.objectGroupData.some(
        //     (data: any) => data.objectGroupMasterId === list.objectGroupMasterId
        //   )
        // )
        // .map((list: any) => ({
        //   objectGroupMasterId: list.objectGroupMasterId,
        //   groupName: list.groupName
        // }));

        this.objectGroupDataSelectedList = []

        const ids = new Set(
          response.response?.groupMasterList.map((x: any) => x.objectGroupMasterId)
        );

        this.objectGroupDataSelectedList = this.objectGroupData
          .filter((item: any) => ids.has(item.objectGroupMasterId))
          .map((item: any) => ({
            objectGroupMasterId: item.objectGroupMasterId,
            groupName: item.groupName
          }));

        // this.objectGroupDataSelectedList = this.objectGroupData
        //   ?.filter((item: any) => response.response?.groupMasterList?.includes(item.locationId))
        //   ?.map((item: any) => ({
        //     locationId: item.locationId,
        //     zone: item.zone
        //   })) || [];


        this.departmentSelectedList = []

        this.departmentSelectedList = this.departmentList
          ?.filter((departmentItem: any) => response.response?.department?.includes(departmentItem.departmentInfoId))
          ?.map((departmentItem: any) => ({
            departmentInfoId: departmentItem.departmentInfoId,
            departmentName: departmentItem.departmentName
          })) || [];

        this.branchSelectedList = this.branchList
          ?.filter((branchItem: any) => response.response?.branch?.includes(branchItem.branchMasterId))
          ?.map((branchItem: any) => ({
            branchMasterId: branchItem.branchMasterId,
            name: branchItem.name
          })) || [];

        if (response.response.userParameters) {
          for (var i = 0; i < response.response.userParameters.length; i++) {
            for (var j = 0; j < this.userParams.length; j++) {
              if (response.response.userParameters[i].key == this.userParams[j].name) {
                this.userParams[j].value = response.response.userParameters[i].value
              }
            }
          }
        }
      },
      (error: any) => {
        console.log(error)
      }
    )
  }



  isLoading: any = false
  first3: number = 0;

  rows3: number = 10;


  onPageChange3(event: any) {
    this.first3 = event.first;
    this.rows3 = event.rows;
    console.log(event)
  }



  updateUser() {

    if (!this.editForm.valid) {
      console.log(this.form.value)
      this.toastr.error("please fill required fields");
      return
    }

    let keyValues: any = []

    for (let i = 0; i < this.userParams.length; i++) {
      keyValues.push(
        {
          "key": this.userParams[i].name,
          "value": this.userParams[i].value
        }
      )
    }

    let dashboardIds: any = []

    for (let list of this.dashboardSelectedList) {
      dashboardIds.push(list.dashboardId)
    }

    let locations: any = []

    for (let list of this.locationSelectedList) {
      locations.push(list.locationId)
    }

    let groupMasterList = this.objectGroupData.filter((list: any) =>
      this.objectGroupDataSelectedList.some(
        (selected: any) => selected.objectGroupMasterId === list.objectGroupMasterId
      )
    );


    let branch: any = []

    for (let list of this.branchSelectedList) {
      branch.push(list.branchMasterId)
    }

    let department: any = []

    for (let list of this.departmentSelectedList) {
      department.push(list.departmentInfoId)
    }

    console.log(this.editForm.value)

    let body: any = {
      "id": this.editForm.get('id').value,
      "version": 0,
      "isActive": true,
      "description": "",
      "userId": Number(this.editForm.get('userId').value),
      "userType": String(this.editForm.get('userType').value),
      "userName": String(this.editForm.get('userName').value),
      "userMobileNo": String(this.editForm.get('userMobileNo').value),
      "userEmail": String(this.editForm.get('userEmail').value),
      "dashboardIds": dashboardIds,
      "locations": locations,
      "groupMasterList": groupMasterList,
      "department": department,
      "branch": branch,
      "password": "",
      "imageURL": "",
      "companyName": this.userData[0]?.companyName || '',
      "otp": "",
      "otpGenerateDateTime": 0,
      "keyValues": keyValues,
      "cid": this.cid,

      "authMode": this.userData[0]?.authMode || 0,
      "roleLevel": this.userData[0]?.roleLevel || 0,
      "allowDeploymentFromAnyLocation": this.userData[0]?.allowDeploymentFromAnyLocation || false,

      "branchId": this.userData[0]?.branchId || 0,
      "reportsTo": this.userData[0]?.reportsTo || 0,

      "preferences": this.userData[0]?.preferences || {},
      "isInnerUser": this.userData[0]?.isInnerUser || false,
      "roleIdSet": this.userData[0]?.roleIdSet || [],
      "location": this.userData[0]?.location || "",
      "roleSet": this.userData[0]?.roleSet,
      "isOnSite": this.editForm.get('isOnSite')?.value || false
    }


    if (this.editForm.get('reportsTo').value != null && this.editForm.get('reportsTo').value != "") {
      body.reportsTo = Number(this.editForm.get('reportsTo').value)
    }

    console.log(body)
    this.generic_service.updateUser(body).subscribe(
      (response: any) => {
        console.log(response)
        
        let newIsOnSite = this.editForm.get('isOnSite')?.value || false;
        if (this.userData[0]?.isOnSite !== newIsOnSite) {
          this.generic_service.updateOnSiteForUser(body.userId, newIsOnSite).subscribe();
        }

        this.getAllUsers(this.pageNumber, this.recordsPerPage)
        this.toastr.success("Successfully Updated");
        this.cancelModel()
        this.getParamByType()
        // this.editForm.clear()
      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error.errors[0].description);
      },
    )
  }




  deleteUser() {
    this.generic_service.deleteUser(this.deleteId).subscribe(
      (res: any) => {
        console.log(res)
        this.toastr.success("Successfully Deleted");
        this.getAllUsers(this.pageNumber, this.recordsPerPage)
        this.cancelModel();
      }, err => {
        this.toastr.error(err.error.errors[0].description);
      }
    )
  }

  del(id: any) {
    this.deleteId = id
  }

  selectDelete(id: any, record: any) {
    this.deleteId = id;
    this.recordId = record.userId;
    this.recordName = record.userName;
  }


  refreshSearch() {
    this.searchUser = "";
    this.pageNumber = 0;
    this.first = 0;
    this.paginatorVisible = false;


    setTimeout(() => {
      this.paginatorVisible = true;
      this.getAllUsers(this.pageNumber, this.recordsPerPage);
    });
  }


  roleList: any = []

  isShowDelete: any = false

  deleteClose() {
    this.selectedRoleData = []

    this.isShowDelete = false
    for (let list of this.roleList) {
      list.isSelected = false
    }
  }

  roleSelect(roleId: any) {
    let isDelete: any = false
    for (let list of this.roleList) {
      if (list.roleId == roleId) {
        list.isSelected = !list.isSelected
      }
      if (list.isSelected) {
        isDelete = true
      }
    }

    if (isDelete) {
      this.isShowDelete = true
    } else {
      this.isShowDelete = false
    }
  }

  deleteUserRole() {
    this.rolesSelectedList = [];
    this.selectedRoleData = [];
    for (let list of this.roleList) {
      this.generic_service.deleteUserRole(this.selectedUserData[0].userMobileNo, list.roleId).subscribe(
        (res: any) => {
          console.log(res)
        }
      )
    }
    setTimeout(() => {
      if (this.searchUser != "") {
        this.searchCustomer(this.pageNumber, this.recordsPerPage)
      } else {
        this.getAllUsers(this.pageNumber, this.recordsPerPage);
      }
      this.getUserRoleByUserMobileAndCid(this.selectedUserData[0].userMobileNo)
    }, 500);
  }

  getUserRoleByUserMobileAndCid(mobile: any) {
    this.roleList = []
    this.isShowDelete = false
    this.generic_service.getUserRoleByUserMobileAndCid(mobile).subscribe(
      (res: any) => {
        if (res.response && res.response.length != 0) {
          for (let list of res.response) {
            let obj: any = {
              roleId: list.roleId,
              roleName: list.roleName,
              isSelected: false
            }
            this.roleList.push(obj)
          }
        }



      }
    )
  }

  updateOnSite(event: any, data: any) {
    const isOnSite = event.target.checked;
    this.generic_service.updateOnSiteForUser(data.userId, isOnSite).subscribe(
      (response: any) => {
        this.toastr.success("Updated successfully");
        data.isOnSite = isOnSite;
      },
      (error: any) => {
        console.error(error);
        this.toastr.error("Failed to update");
        event.target.checked = !isOnSite; // revert toggle
        data.isOnSite = !isOnSite; // revert model
      }
    );
  }


  getError(controlName: string): string | null {
    const control = this.form.get(controlName);

    if (!control || !control.touched || control.valid) {
      return null;
    }

    if (control.hasError('required')) {
      return 'This field is required';
    }

    if (control.hasError('pattern')) {
      return 'Invalid format';
    }

    if (control.hasError('minlength') || control.hasError('maxlength')) {
      return 'Invalid length';
    }

    if (control.hasError('email')) {
      return 'Invalid email address';
    }

    return null;
  }

  scrollToFirstInvalidControl() {
    const firstInvalid = document.querySelector('.ng-invalid');
    firstInvalid?.scrollIntoView({ behavior: 'smooth' });
  }



}